// dev environment (RT-2612, after the cutover of 2026-10-14).
//
// The new architecture shares the dev AWS account with the legacy iot-platform;
// the two run side by side on separate hosts:
//
//   new     https://dev.iot.radoff.life     -> v2.api.dev.iot.radoff.life   (this build)
//   legacy  https://v1.dev.iot.radoff.life  -> api.dev.iot.radoff.life/api/*
//
// This build calls the new architecture's base paths (/admin, /data, /analytics)
// on the v2 API host. The transitional v2.dev.iot.radoff.life site was retired.
//
// The Cognito pool is deliberately the same one the legacy frontend uses — it is
// shared during coexistence and becomes the new architecture's pool later, so
// users do not have to be migrated.
export const environment = {
  production: false,
  appVersion: '3.0.1',
  // API host root. The services append /admin, /data, /analytics.
  apiUrl: 'https://v2.api.dev.iot.radoff.life',
  auth: {
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_5SsvW9t6S',
    userPoolWebClientId: '1dok6g5ilbdhb5oisfmj1sla56',
    identityPoolId: 'eu-west-1:ea21ba4b-c02c-423d-9179-ac54930fba9f',
    oauth: {
      domain: 'yama-dev.auth.eu-west-1.amazoncognito.com',
      scopes: ['email', 'profile', 'openid'] as any,
      redirectSignIn: ['https://dev.iot.radoff.life/oauth', 'http://localhost:4200/oauth'],
      redirectSignOut: ['https://dev.iot.radoff.life/auth/login', 'http://localhost:4200/auth/login'],
      responseType: 'code' as any
    }
  }
};
